import ajaxCall from './ajaxcall';
import report11332 from '../report/11332_batch';
import * as Base from '../base/mbase';
import Env from './env.js';

function Dialog(option) {
    option = option || {}
    option.appitem = option.appitem || {}
    this.option = option
    this.appid = option.appid || ''
    this.icon = option.appitem.IconURL || ''
    this.name = option.appitem.Name || ''
    this.uiarea = option.uiarea || 3411
    this.scene = option.scene || 34

    this.successCbk = option.success || function () { }
    this.cancelCbk = option.cancel || function () { }
    this.init()

    WXGAME && WXGAME.WxBridge.invoke("setGameTab", { isShowTab: 0 })
}

Dialog.prototype.init = function () {
    var self = this
    this.insertStyle()
    this.insertDom()
    this.insertData()
    this.insertButton()

    this.dialogDom = document.querySelector('.launch-privilege-dialog')
    this.maskDom = document.querySelector('.launch-privilege-dialog__mask')
    this.panelDom = document.querySelector('.launch-privilege-dialog__panel')
    this.bottomDom = document.querySelector('.launch-privilege-dialog__bottom')
    setTimeout(function () {
        self.dialogDom.style.bottom = 0
        self.maskDom.style.opacity = 1
        self.panelDom.style.bottom = 0

        self.report({
            op: 1
        })
    }, 0)

    this.bindEvent()
    this.getData().then(function (res) {
        if (res.errcode === 0) {
            var privilege = res.launch_privilege || {}
            self.updateData(privilege)
        } else {
        }
    }).catch(function (res) {

    })
}

Dialog.prototype.report = function (obj) {
    var self = this;
    var map = {
        scene: 'iSceneId',
        uia: 'iUIArea',
        pid: 'iPositionId',
        ext: 'sExternInfo',
        aid: 'iActionId',
        op: 'iOpType',
        gid: 'sGameId',
        ssid: 'iSourceSceneId'
    };

    var defaultRep = {
        gid: self.appid,
        scene: self.scene,
        uia: self.uiarea,
        ssid: self.ssid
    };

    var rep = Base.extend(defaultRep, obj);

    for (var key in rep) {
        if (map[key]) {
            rep[map[key]] = rep[key];

            delete rep[key];
        }
    }

    console.log(rep);
    report11332([rep])
}

Dialog.prototype.getData = function () {
    var self = this;

    return new Promise(function (resolve, reject) {
        ajaxCall(
            '/cgi-bin/gamewap/getgamebaseextrafor',
            {
                appid: self.appid,
                need_launch_privilege: true
            },
            function (res) {
                resolve(res)
            },
            function () {
                reject()
            }
        )
    })
}

Dialog.prototype.updateData = function (data) {
    var descDom = document.querySelector('.launch-privilege-dialog-desc')
    var listDom = document.querySelector('.launch-privilege-dialog__list')
    if (descDom) {
        descDom.innerHTML = data.title || '从微信启动游戏，享启动特权'
    }

    var list = [];
    if (!(listDom && data.item_list && data.item_list.length)) {
        list = [{
            icon_url: 'https://res.wx.qq.com/wechatgame/product/cdn/moment/gift_7595b90f.svg',
            desc: '启动礼包',
        }, {
            icon_url: 'https://res.wx.qq.com/wechatgame/product/cdn/moment/gift_43be081a.svg',
            desc: '金币/经验加成',
        }, {
            icon_url: 'https://res.wx.qq.com/wechatgame/product/cdn/moment/7da3c830.svg',
            desc: '游戏内身份展示'
        }]
    } else {
        list = data.item_list;
    }

    if (list) {
        var html = ''
        for (var i = 0, len = list.length; i < len; i++) {
            var tmpl = [
                '<div class="launch-privilege-dialog__item">',
                '<div class="launch-privilege-dialog__item-icon" style="background-image:url(' + list[i].icon_url + ')"></div>',
                '<div class="launch-privilege-dialog__item-desc">' + list[i].desc + '</div>',
                '</div>'
            ]
            html += tmpl.join('')
        }

        listDom.innerHTML = html
    }
}

Dialog.prototype.insertStyle = function () {
    var dialogDom = document.getElementById('launch_privilege_dialog_style')
    if (!dialogDom) {
        var dom = document.createElement('style')
        dom.setAttribute('type', "text/css")
        dom.setAttribute('id', "launch_privilege_dialog_style")

        const style = `
.launch-privilege-dialog {
	position: fixed;
	left: 0;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 100002;
}

.launch-privilege-dialog__mask {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	background-color: rgba(0, 0, 0, 0.6);
	transition: opacity .1s linear
}

.launch-privilege-dialog__panel {
	position: absolute;
	left: 0;
	bottom: -100%;
	width: 100%;
	padding: 0 1.1rem;
	min-height: 300px;
	background: #ffffff;
	border-top-left-radius: 12PX;
	border-top-right-radius: 12PX;
    transition: bottom .3s ease-in-out;
    color: rgba(0,0,0,0.9);
}
.wg_dark_mode .launch-privilege-dialog__panel {
    background: #232323;
    color: rgba(255,255,255,0.8);
}

.launch-privilege-dialog__title {
	width: 100%;
	height: 64px;
	display: flex;
}

.launch-privilege-dialog__icon {
	width: 24px;
	height: 64px;
	margin-right: 8px;
	background-repeat: no-repeat;
	background-size: 24PX 24PX;
	background-position: center;
}

.launch-privilege-dialog__title {
	height: 64px;
	line-height: 64px;
	opacity: 0.9;
	font-family: PingFangSC-Medium;
	font-size: 15PX;
}

.launch-privilege-dialog-desc {
	opacity: 0.9;
	font-family: PingFangSC-Medium;
	font-size: 17PX;
	varter-spacing: 0;
	line-height: 24px;
	height: 24px
}

.launch-privilege-dialog__list {
	width: 100%;
	display: flex;
	min-height: 96px;
	flex-wrap: wrap;
}

.launch-privilege-dialog__item {
	width: 55%;
	display: flex;
	margin-top: 24px;
}

.launch-privilege-dialog__item:nth-child(2n) {
	width: 45%;
}

.launch-privilege-dialog__item-icon {
	width: 24px;
	height: 24px;
	margin-right: 8px;
	background-repeat: no-repeat;
	background-size: 24PX 24PX;
	background-position: center;
}

.launch-privilege-dialog__item-desc {
	height: 24px;
	line-height: 24px;
	font-family: PingFang-SC-Regular;
	font-size: 14PX;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap!important;
	max-width: 75%
}

.launch-privilege-dialog__bottom {
	width: 11.7rem;
	display: flex;
	padding: 30px 0px;
	justify-content: space-between;
	margin: 0 auto;
}

.launch-privilege-dialog__button {
	width: 5.5rem;
	height: 2rem;
    background: rgba(0, 0, 0, 0.05);
	color: #06ae56;
	border-radius: 4px;
	font-family: PingFangSC-Medium;
	font-size: 17PX;
	varter-spacing: 1px;
	text-align: center;
	line-height: 2rem;
}
.wg_dark_mode .launch-privilege-dialog__button {
    background: rgba(255, 255, 255, 0.08);
	color: rgba(255, 255, 255, 0.8);
}

.launch-privilege-dialog__button-right {
	background: #07C160;
	color: #FFFFFF;
}
.wg_dark_mode .launch-privilege-dialog__button-right {
	background: #07C160;
	color: #FFFFFF;
}
`

        dom.innerHTML = style
        var head = document.getElementsByTagName('head')[0]
        head.appendChild(dom)
    }
}

Dialog.prototype.insertDom = function () {
    var dialogDom = document.getElementById('launch_privilege_dialog_dom')
    if (!dialogDom) {
        var dom = document.createElement('div')
        dom.setAttribute('id', "launch_privilege_dialog_dom")
        dom.classList.add(`launch-privilege-dialog`)
        if (Env.isDarkMode) {
            dom.classList.add(`wg_dark_mode`)
        }
        var div = [
            '<div class="launch-privilege-dialog__mask"></div>',
            '<div class="launch-privilege-dialog__panel">',
            '<div class="launch-privilege-dialog__title"></div>',
            '<div class="launch-privilege-dialog__content">',
            '<div class="launch-privilege-dialog-desc"> </div>',
            '</div>',
            '<div class="launch-privilege-dialog__bottom"></div>',
            '</div>',
        ]

        dom.innerHTML = div.join('')
        document.body.appendChild(dom)
    }
}

Dialog.prototype.insertData = function () {

    var html = [
        '<div class="launch-privilege-dialog__icon" style="background-image:url(' + this.icon + ')"></div>',
        '<div class="launch-privilege-dialog__name">即将启动“' + this.name + '”</div>',
    ]

    var dom = document.querySelector('.launch-privilege-dialog__title')

    dom && (dom.innerHTML = html.join(''));

    var dom = document.querySelector('.launch-privilege-dialog__content')
    var html = '<div class="launch-privilege-dialog__list"></div>'

    dom && (dom.innerHTML += html);
}

Dialog.prototype.insertButton = function () {
    var dom = document.querySelector('.launch-privilege-dialog__bottom')

    var html = [
        '<div class="launch-privilege-dialog__button launch-privilege-dialog__button-left">取消</div>',
        '<div class="launch-privilege-dialog__button launch-privilege-dialog__button-right">启动</div>',
    ]

    if (dom) {
        dom.innerHTML += html.join('')
    }
}

Dialog.prototype.bindEvent = function () {
    var self = this
    this.maskDom.addEventListener('click', function () {
        self.closeEvent()
    })

    this.bottomDom.addEventListener('click', function (e) {
        var className = e.target && e.target.className || ''
        if (className.indexOf('left') > -1) {
            self.closeEvent()

            self.report({
                pid: 2,
                aid: 61
            })
        } else {

            self.report({
                pid: 1,
                aid: 22
            })
            self.successCbk()
            self.closeEvent()
        }
    })
}

Dialog.prototype.closeEvent = function () {
    var self = this

    self.panelDom.style.bottom = '-100%'
    setTimeout(function () {
        self.maskDom.style.opacity = 0

        WXGAME && WXGAME.WxBridge.invoke("setGameTab", { isShowTab: 1 })
    }, 200)
    setTimeout(function () {
        self.dialogDom.style.bottom = '-100%'

        self.dialogDom.parentNode.removeChild(self.dialogDom)
    }, 350)

    this.cancelCbk()
}

export default Dialog;